<template>
  <div>
    <KTCodePreview v-bind:title="'In phiếu'">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          @click="printData"
          style="width: max-content"
        >
          <i class="fas fa-print"></i>
          In phiếu
        </b-button>
      </template>
      <template v-slot:preview>
        <div id="printMe">
          <b-row style="display: block" class="mb-10">
            <div class="text-center">
              <h2>PHIẾU CHUYỂN KHO</h2>
            </div>
          </b-row>
          <b-row>
            <b-col cols="12">
              <p class="font-size-print">
                <span class="custom-lable-text">Mã phiếu</span>
                : {{ stockSlip.code }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <p class="font-size-print">
                <span class="custom-lable-text">Ngày</span>
                :
                {{ moment(stockSlip.createdAt).format('DD/MM/YYYY HH:mm:ss') }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <p class="font-size-print">
                <span class="custom-lable-text">Kho chuyển</span>
                : {{ stockSlip.sourceWarehouse?.name || '' }}
              </p>
            </b-col>
            <b-col cols="4">
              <p class="font-size-print">
                <span class="custom-lable-text">Kho nhận</span>
                : {{ stockSlip.destinationWarehouse?.name || '' }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <p class="font-size-print">
                <span class="custom-lable-text">Địa chỉ</span>
                : {{ stockSlip.sourceWarehouse?.address || '' }}
              </p>
            </b-col>
            <b-col cols="4">
              <p class="font-size-print">
                <span class="custom-lable-text">Địa chỉ</span>
                : {{ stockSlip.destinationWarehouse?.address || '' }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <p class="font-size-print">
                <span class="custom-lable-text">Ghi chú</span>
                : {{ stockSlip.description }}
              </p>
            </b-col>
            <b-col cols="4">
              <p class="font-size-print">
                <span class="custom-lable-text">Người lập</span>
                : {{ stockSlip.userCreated?.fullName }}
              </p>
            </b-col>
          </b-row>
          <b-table
            :items="listItem"
            :fields="fields"
            :bordered="true"
            :hover="true"
          >
            <template v-slot:cell(productCode)="row">
              {{ row.item.product?.code }}
            </template>
            <template v-slot:cell(productName)="row">
              {{ row.item.product?.name }}
            </template>
            <template v-slot:cell(productInfo)="row">
              <div v-if="row.item?.chassisNumber && row.item?.engineNumber">
                <span>SK: {{ row.item?.chassisNumber }}</span
                ><br />
                <span>SM: {{ row.item?.engineNumber }}</span>
              </div>
              <div v-if="row.item?.serialNumber">
                <span>SERI: {{ row.item?.serialNumber }}</span>
              </div>
            </template>
            <template v-slot:cell(approveQuantity)="row">
              {{ formatMoney(row.item.quantity) }}
            </template>
            <template v-slot:cell(confirmQuantity)="row">
              {{ formatMoney(row.item.quantity) }}
            </template>
            <template slot="bottom-row">
              <td
                v-bind:colspan="4"
                class="text-right font-weight-bolder"
                style="font-weight: 600,color: '#181c32'"
              >
                <span class="font-size-print">Tổng:</span>
              </td>
              <td class="text-right font-weight-bolder">
                <span class="font-size-print">{{
                  formatMoney(sumQuantity)
                }}</span>
              </td>
              <td class="text-right font-weight-bolder">
                <span v-if="stockSlip.approveBy" class="font-size-print">{{
                  formatMoney(sumApproveQuantity)
                }}</span>
              </td>
              <td class="text-right font-weight-bolder">
                <span v-if="stockSlip.confirmBy" class="font-size-print">{{
                  formatMoney(sumConfirmQuantity)
                }}</span>
              </td>
            </template>
          </b-table>
          <b-row>
            <b-col class="text-center">
              <p class="mb-0 font-size-print">
                <span class="custom-lable-text">Người lập phiếu</span>
              </p>
              <p class="font-size-print">(Ký, họ tên)</p>
            </b-col>
            <b-col>
              <p class="mb-0 font-size-print">
                <span class="custom-lable-text">Người giao hàng</span>
              </p>
              <p class="font-size-print">(Ký, họ tên)</p>
            </b-col>
            <b-col>
              <p class="mb-0 font-size-print">
                <span class="custom-lable-text">Người nhận hàng</span>
              </p>
              <p class="font-size-print">(Ký, họ tên)</p>
            </b-col>
            <b-col
              ><p class="mb-0 font-size-print">
                <span class="custom-lable-text">Thủ kho</span>
              </p>
              <p class="font-size-print">(Ký, họ tên)</p>
            </b-col>
            <b-col
              ><p class="mb-0 font-size-print">
                <span class="custom-lable-text">Giám đốc</span>
              </p>
              <p class="font-size-print">(Ký, họ tên)</p>
            </b-col>
          </b-row>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import _ from 'lodash';
// import { printData } from '../../../utils/common';
import { STOCK_SLIP_STATUS } from '../../../utils/enum';
import moment from 'moment';

export default {
  data() {
    return {
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '5%',
          },
          thClass: 'font-size-print',
          tdClass: 'text-center font-size-print',
        },
        // {
        //   key: 'barCode',
        //   label: 'Mã vạch',
        //   thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        // },
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          thClass: 'font-size-print',
          tdClass: 'font-size-print',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          thClass: 'font-size-print',
          tdClass: 'font-size-print',
        },
        {
          key: 'productInfo',
          label: 'Số khung - Số máy / Số serial',
          thStyle: { fontWeight: 600, color: '#181c32', width: '17%' },
          thClass: 'font-size-print',
          tdClass: 'font-size-print',
        },
        {
          key: 'quantity',
          label: 'SL yêu cầu',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '9%' },
          thClass: 'font-size-print',
          tdClass: 'text-right font-size-print',
          formatter: (value) => {
            return this.formatMoney(value);
          },
        },
        {
          key: 'approveQuantity',
          label: 'SL duyệt',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '9%' },
          thClass: 'font-size-print',
          tdClass: 'text-right font-size-print',
          // formatter: () => {
          //   return this.stockSlip.approveBy
          //     ? this.formatMoney(this.stockSlip.quantity)
          //     : '';
          // },
        },
        {
          key: 'confirmQuantity',
          label: 'SL xác nhận',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '9%' },
          thClass: 'font-size-print',
          tdClass: 'text-right font-size-print',
          // formatter: () => {
          //   return this.stockSlip.confirmBy
          //     ? this.formatMoney(this.stockSlip.quantity)
          //     : '';
          // },
        },
      ],
      listItem: [],
      stockSlip: {
        code: '',
        sourceStoreName: '',
        destinationStoreName: '',
        createdAt: '',
        sourceStoreAddress: '',
        destinationStoreAddress: '',
        createBy: '',
        description: '',
        status: 1,
      },
      sumQuantity: 0,
      sumApproveQuantity: 0,
      sumConfirmQuantity: 0,
      STOCK_SLIP_STATUS: STOCK_SLIP_STATUS,
    };
  },
  components: {
    KTCodePreview,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'In phiếu kho chuyển kho' },
    ]);
    this.getStockSlipById();
  },
  methods: {
    moment,
    printData() {
      const prtHtml = document.getElementById('printMe').innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
      );

      WinPrint.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="main.css" />
            <link rel="stylesheet" media="print" href="print.css" />
            ${stylesHtml}
            <style>
                .font-size-print,.custom-lable-text {font-size: 14pt !important; color: black;line-height: 1.5;}
                .font-size-gift {font-size: 18px !important; color: black;}
                .font-size-name{ font-size: 20px !important; color: black;}
                .font-size-warranty{ font-size: 20px !important; color: black;}
                .font-size-product-info{ font-size: 20px !important; color: black;}
                .font-size-price{ font-size: 30px !important; font-weight: bold !important;}
                .text-download-app {font-size: 14px !important; font-weight: 550 !important; margin-top: 4px;}
                .item-print {
                    width: 100% !important;
                    margin-left: 0px !important;
                  }
              </style>
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>
      `);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.onload = function () {
        WinPrint.print();
        WinPrint.close();
      };
    },
    formatMoney: function (number) {
      if (!number) return 0;
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    getStockSlipById: async function () {
      const stockSlipId = this.$route.query.id;
      await ApiService.get(`/stockslip-transfer/${stockSlipId}/detail`).then(
        (data) => {
          const responseData = data.data.data;
          responseData.stockSlipTransferDetail.map((element, index) => {
            const item = {
              count: index + 1,
              ...element,
            };
            this.listItem.push(item);
          });
          this.stockSlip = responseData;
          this.sumQuantity = _.sumBy(this.listItem, 'quantity');
          this.sumApproveQuantity = _.sumBy(this.listItem, 'quantity');
          this.sumConfirmQuantity = _.sumBy(this.listItem, 'quantity');

          // this.sumApproveQuantity = _.sumBy(this.listItem, 'approveQuantity');
          // this.sumConfirmQuantity = _.sumBy(this.listItem, 'confirmQuantity');
        },
      );
    },
  },
};
</script>

<style scoped>
.custom-lable-text {
  font-size: 13px;
  font-weight: 500 !important;
}
</style>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>
